import { ReactiveState, useReactiveStateHandler } from "reactive-state-handler";
import SocketIOClient from "socket.io-client";
import AppStateHandler from "./AppStateHandler";

export type ChatStateType = {
  chatList: Array<any>;
  activeChatId: string;
  userId: string;
  activeChatData: Array<any>;
  isBlocked: boolean;
  hasBlocked: boolean;
  online: boolean;
  loading: boolean;
};

class ChatSocketState extends ReactiveState {
  ws: SocketIOClient.Socket | undefined;
  navigationRef: any;

  connect = () => {
    this.ws = SocketIOClient(
      "https://houmti.io",
      {
        reconnection: true,
      }
    );
    this.addListener();
    this.init();
  };

  init = () => {
    const { user } = AppStateHandler.getState();
    if (this.ws) {
      try {
        this.ws.emit("init", { subId: user?.username }, (data: any) => {
          console.log(data);
          console.log("Connected...");
          this.setState({ online: true });
        });
      } catch (error) {
        console.log(error)
      }
    }
  };

  addListener = () => {
    if (this.ws) {
      this.ws.on("connect", () => {
        this.init();
      });
      this.ws.on("disconnect", () => {
        console.log("Disconnected...");
        this.setState({ online: false });
      });
      this.ws.on("receiveMessage", (data: any) => {
        console.log("receiveMessage", data);

        const { activeChatData, userId } = this.getState();

        if (userId === data.senderId) {
          const msgData = {
            _id: data.msgId,
            text: data.message,
            createdAt: data.createdAt,
            user: {
              _id: data.senderId,
              name: data.senderName,
              avatar: data.senderImage,
            },
          };

          this.setState({
            activeChatData: [msgData, ...activeChatData],
            activeChatId: data.chatId,
          });
          this.readMessage();
        } else {
          this.getChatList();
        }
      });
      this.ws.on("receiveChatList", (data: any) => {
        console.log("receiveChatList", data);
        const parseChatList = JSON.parse(data.body);
        this.setState({ chatList: parseChatList?.data });
      });
      this.ws.on("listenBlock", (data: any) => {
        const { userId } = this.getState();

        if (userId === data.senderId || userId === data.receiverId) {
          const { isBlocked, blocked } = data;
          this.setState({
            isBlocked: isBlocked === 1,
            hasBlocked: blocked.indexOf(userId) !== -1,
          });
        }
      });
    }
  };

  manualDisconnect = () => {
    if (this.ws) {
      this.ws.emit("manualDisconnect", () => { });
    }
  };

  removeListener = () => {
    if (this.ws) {
      this.ws.removeEventListener("receiveMessage");
      this.ws.removeEventListener("connect");
    }
  };

  getChatList = () => {
    const { user } = AppStateHandler.getState();
    if (this.ws) {
      this.ws.emit("chatList", { subId: user?.username }, (data: any) => {
        console.log("chatList", JSON.parse(data.body));
        const parseChatList = JSON.parse(data.body);
        this.setState({ chatList: parseChatList?.data });
      });
    }
  };

  readMessage = () => {
    const { activeChatId } = this.getState();
    if (this.ws) {
      this.ws.emit("readMessage", { chatId: activeChatId }, (data: any) => {
        console.log("readMessage", JSON.parse(data.body));
        // const parseChatList = JSON.parse(data.body);
        // this.setState({chatList: parseChatList?.data});
        this.getChatList();
      });
    }
  };

  getChatHistory = (receiverId: string) => {
    console.log(receiverId);
    this.setState({ loading: true });
    const { user } = AppStateHandler.getState();
    if (this.ws) {
      this.ws.emit(
        "chatHistory",
        { senderId: user?.username, receiverId },
        (__data: any) => {
          console.log("chatHistory", JSON.parse(__data.body));
          if (__data.statusCode === 200) {
            const _data = JSON.parse(__data.body);
            const { data, chatId, blocked, isBlocked } = _data;
            const msgData = data.map((___data: any) => {
              return {
                _id: ___data.msgId,
                text: ___data.message,
                createdAt: ___data.createdAt,
                user: {
                  _id: ___data.senderId,
                  name: ___data.senderName,
                  avatar: ___data.senderImage,
                },
              };
            });
            this.setState({
              activeChatData: msgData,
              activeChatId: chatId,
              isBlocked: isBlocked === 1,
              hasBlocked: blocked.indexOf(receiverId) !== -1,
              loading: false,
            });
            this.readMessage();
          }
        }
      );
    }
  };

  sendMessage = ({ receiverId, chatId, message }: any) => {
    const { user } = AppStateHandler.getState();
    if (this.ws) {
      this.ws.emit(
        "sendMessage",
        { senderId: user?.username, receiverId, chatId, message },
        (__data: any) => {
          if (__data.statusCode === 200) {
            const _data = JSON.parse(__data.body);
            const { data, chatId: activeChatId } = _data;
            const { activeChatData } = this.getState();
            const msgData = {
              _id: data.msgId,
              text: data.message,
              createdAt: data.createdAt,
              user: {
                _id: data.senderId,
                name: data.senderName,
                avatar: data.senderImage,
              },
            };

            this.setState({
              activeChatId,
              activeChatData: [msgData, ...activeChatData],
            });
            this.setState({ loading: false });
          }
        }
      );
    }
  };

  blockUser = () => {
    const { userId } = this.getState();
    if (this.ws && userId) {
      this.ws.emit("blockUser", { receiverId: userId }, (__data: any) => {
        console.log("blockUser", __data);
        if (__data.statusCode === 200) {
          this.setState({ hasBlocked: true });
        }
      });
    }
  };

  unBlockUser = () => {
    const { userId } = this.getState();
    if (this.ws && userId) {
      this.ws.emit("unBlockUser", { receiverId: userId }, (__data: any) => {
        console.log("unBlockUser", __data);
        if (__data.statusCode === 200) {
          this.setState({ hasBlocked: false });
        }
      });
    }
  };
}

const ChatStateHandler: ChatSocketState = new ChatSocketState({
  chatList: [],
  activeChatId: null,
  activeChatData: [],
  online: false,
  loading: false,
  hasBlocked: false,
  isBlocked: false,
  userId: null,
});

export default ChatStateHandler;

type addListener = () => void;

type removeListener = () => void;

export function useChatState(
  filterKeys?: Array<keyof ChatStateType>
): [Partial<ChatStateType>, removeListener, addListener] {
  return useReactiveStateHandler(ChatStateHandler, filterKeys);
}
